import { render, staticRenderFns } from "./SanDianLiu.vue?vue&type=template&id=63db68da&scoped=true"
import script from "./SanDianLiu.vue?vue&type=script&lang=js"
export * from "./SanDianLiu.vue?vue&type=script&lang=js"
import style0 from "./SanDianLiu.vue?vue&type=style&index=0&id=63db68da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db68da",
  null
  
)

export default component.exports